import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { ACTION, CONTINUE_APPLICATION_URL, NEW_ACCESS_LOAN_URL, QUERY_KEY, makeQueryPath, parseQuery, } from 'shared';
import { useLazyGetConsumerApplicationsV1CreditApplicationsTokenTokenQuery } from 'consumer-applications-v1-api';
import { ApplicationFinderForm } from '../../forms';
import { setPersonalInfo, setPractice, setCreditApplication } from '../actions';
function Applicants() {
    const history = useHistory();
    const dispatch = useDispatch();
    const { search } = useLocation();
    const query = parseQuery(search);
    const token = query[QUERY_KEY.TOKEN];
    const [submitting, setSubmitting] = useState(false);
    // API
    const [getCreditApplicationByToken] = useLazyGetConsumerApplicationsV1CreditApplicationsTokenTokenQuery();
    const handleSubmit = (formValues) => {
        setSubmitting(true);
        return getCreditApplicationByToken({
            ssnLastFour: formValues.ssnLastFour,
            dateOfBirth: formValues.dateOfBirth,
            zip: formValues.zip,
            token: token,
        })
            .then((res) => {
            if ('data' in res) {
                handleSubmitSuccess();
                dispatch(setCreditApplication(res.data?.creditApplication));
                dispatch(setPractice(res.data?.location));
                dispatch(setPersonalInfo(res.data?.applicant));
            }
        })
            .finally(() => {
            setSubmitting(false);
        });
    };
    const handleSubmitSuccess = () => {
        let nextActionURL;
        switch (query[QUERY_KEY.ACTION]) {
            case ACTION.CONTINUE:
                nextActionURL = CONTINUE_APPLICATION_URL;
                break;
            case ACTION.NEW_ACCESS_LOAN:
                nextActionURL = NEW_ACCESS_LOAN_URL;
                break;
            default:
                throw new Error(`Unknown applicant action [${query[QUERY_KEY.ACTION]}]`);
        }
        history.push(makeQueryPath(nextActionURL, query));
    };
    return (_jsxs("section", { className: "applicant-container", children: [_jsxs("header", { children: [_jsx("h1", { children: "Identity Verification" }), _jsx("p", { children: "Please provide the following information so we can confirm your identity before moving forward." })] }), _jsx(ApplicationFinderForm, { handleSubmit: handleSubmit, submitting: submitting })] }));
}
export default Applicants;
